import { render } from "./GiftTransaction.vue?vue&type=template&id=7e812d44&scoped=true"
import script from "./GiftTransaction.vue?vue&type=script&lang=js"
export * from "./GiftTransaction.vue?vue&type=script&lang=js"

import "./GiftTransaction.vue?vue&type=style&index=0&id=7e812d44&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e812d44"]])

export default __exports__